<script lang="ts">
	import { onMount } from "svelte"
	import { Route, Router } from "svelte-routing"

	import { Toaster } from "toaster"
	import { Overlay } from "overlay"
	import { ContextMenu } from "context-menu"

	import { pageInit } from "../../modules/page-events/initPage"

	import Dashboard from "./home/Dashboard.svelte"
	import ProtectedRoute from "../reusable/auth/ProtectedRoute.svelte"
	import AllUsers from "./user/AllUsers.svelte"
	import UserView from "./user/user-view/UserView.svelte"
	import DeviceView from "./device/device-view/DeviceView.svelte"
	import AllDevices from "./device/AllDevices.svelte"
	import TestStation from "./test-station/TestStation.svelte"
	import MediaManager from "./media/MediaManager.svelte"
	import PrintPreview from "./print-preview/PrintPreview.svelte"
	import MassUpdate from "./mass-update/MassUpdate.svelte"
	import RemoteApp from "./device/remote/RemoteApp.svelte"
	import SnapshotSelect from "./snapshot-select/SnapshotSelect.svelte"

	let isLoading = true

	onMount(async () => {
		try {
			await pageInit.initPageLoad(true)
			isLoading = false
		} catch (e) {
			console.error(e)
		}
	})
</script>

<Router>
	<ProtectedRoute path="/admin/" component={Dashboard} />
	<ProtectedRoute path="/admin/user" component={AllUsers} />
	<ProtectedRoute path="/admin/user/:id" component={UserView} />
	<ProtectedRoute path="/admin/device" component={AllDevices} />
	<ProtectedRoute path="/admin/device/:id" component={DeviceView} />
	<ProtectedRoute path="/admin/device/:id/remote" component={RemoteApp} />
	<ProtectedRoute path="/admin/snapshots" component={SnapshotSelect} />
	<ProtectedRoute path="/admin/testing" component={TestStation} />
	<ProtectedRoute path="/admin/print-preview" component={PrintPreview} />
	<ProtectedRoute path="/admin/mass-update" component={MassUpdate} />
	<ProtectedRoute path="/admin/media" component={MediaManager} />
	<ProtectedRoute path="/admin/media/:id" component={MediaManager} />
</Router>

<ContextMenu />
<Toaster />
<Overlay />

<style>
</style>
